import React from "react";
import { Helmet } from "react-helmet-async";

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>
          Vinayak24x7 Terms & Conditions | Roadside Assistance Jaipur
        </title>
        <meta
          name="description"
          content="Read the terms and conditions for using our 24x7 car breakdown and roadside assistance service in Jaipur."
        />
        <link rel="canonical" href="https://vinayak24x7jaipur.com/terms" />
      </Helmet>
      <div className="main-content" style={{ textAlign: "justify" }}>
        {/* Section: Blog */}
        <section className="my-5">
          <div className="container">
            <h1
              className="title mb-5 text-center"
              style={{
                fontWeight: "900",
                color: "#f9a602",
              }}
            >
              Terms &amp; Conditions
            </h1>
            <div className="row">
              <div className="col-md-12 blog-pull-right">
                <div className="single-service">
                  <img
                    src="/images/banner-terms.jpg"
                    alt="Terms & Conditions"
                    title="Terms & Conditions"
                    className="img-fluid mb-5"
                  />
                  <h3 className="text-theme-colored">Terms &amp; Conditions</h3>
                  <p>
                    Why Buy a Roadside Assistance Plan From Vinayak 24x7 ? :-
                  </p>
                  <p>More Savings: -</p>
                  <p>
                    Experiencing a vehicle breakdown is not only stressful but
                    also costly. When you're on the road, authorized workshops
                    are scattered all over the place, and towing your vehicle
                    over a long distance can easily make you back a few thousand
                    dollars - which isn't the best thing to do.
                  </p>
                  <p>More Preference:-</p>
                  <p>
                    It takes a lot of conviction to trust someone to take care
                    of your safety and well-being. We appreciate the loyalty
                    that our customers show to us. Likewise, we are determined
                    and faithful to the needs and requirements of our customers
                    and offer them an enriching experience which guarantees
                    their mobility and their insurance at the earliest.
                  </p>
                  <p>More Comfort:-</p>
                  <p>
                    In an era when independent shuttles have become more of a
                    requirement than a rage, there is a growing concern about
                    having a ubiquitous safety net on the road, whether for
                    yourself or your loved ones. Whether it's your wife driving
                    after her trip to the mall or your daughter who has just
                    started driving - our roadside assistance plan is always
                    there to protect you and your loved ones from any unforeseen
                    circumstances.
                  </p>

                  <p>What is Roadside Assistance : -</p>
                  <p>
                    Roadside Assistance (RSA) cover offers the much-needed
                    relief to a car owner if his/her vehicle breaks down or has
                    a mechanical failure on the road or at home. It can be very
                    frustrating to be stranded in an unfamiliar place with no
                    access to a mechanic. This is where the RSA cover comes in
                    handy.
                  </p>
                  <p>Benefits Proposed:-</p>
                  <p>
                    We give below the definition and description of the various
                    advantages that can be offered to customers in different
                    combinations that can be agreed upon.
                  </p>
                  <ul>
                    <li>
                      <em>Flat Tyre Replacement:-</em>
                      <br />
                      If the Covered Vehicle has a punctured or burst tyre,
                      Vinayak 24x7 shall take care of changing it with the spare
                      tyre carried in the Customer’s/Policyholder’s vehicle.
                      <br />
                      We ensure that your vehicle’s flat tyre is repaired or
                      replaced right away on-site so that you can get back on
                      the road in as little time as possible. Our authorized
                      team will reach your location in less than 20-25 Minutes,
                      depending on the location, to fix the punctured tyre or
                      replace it with a spare tyre.
                    </li>
                    <li>
                      <em>Battery Jumpstart:-</em>
                      <br />
                      When your car does not start and the car battery is
                      completely dead then its needs to jumpstart. Our
                      technicians will jumpstart your vehicle in case of a dead
                      or discharged battery in a need on the spot at your
                      location.
                    </li>
                    <li>
                      <em>Fuel Delivery:-</em>
                      <br />
                      If the Covered Vehicle runs out of fuel Vinayak 24x7 shall
                      deliver up to 5 litres of fuel (petrol or diesel only) for
                      Four Wheelers &amp; 2 litres of fuel (petrol only) for
                      Two-Wheelers. The cost of fuel shall be paid by the client
                      on the spot to the service provider. This service is
                      applicable within 20 Km from any other city covered by
                      Vinayak 24x7. Distance limit in this benefit is due to the
                      practical hazards of carrying fuel over long distances.
                    </li>
                    <li>
                      <em>Locked/ Lost Keys:-</em>
                      <br />
                      If the keys to the covered vehicle are locked, Vinayak
                      24x7 will assist the customer as much as keys can be
                      removed from the vehicle. Any glass or storm door
                      breakage, if necessary, must be done beforehand with
                      customer and account approval. If the keys are lost,
                      Vinayak 24x7 transfers the vehicle to the nearest safe
                      place. The customer must organize a set of duplicates at
                      his own expense (unless this cannot be covered under
                      "Replacement keys"). Vinayak 24x7 will surely help, if
                      possible, to find an appropriate solution. To void any
                      misuse, this service must be very limited and provided
                      only to the customer providing valid identification.
                    </li>
                    <li>
                      <em>Replacement Keys: -</em>
                      <br />
                      If the keys necessary to access or operate the Vehicle are
                      lost or misplaced, the Customer may request urgent
                      forwarding of another set from his/her place of residence.
                      Keys must be given, by a person designated by the
                      Customer, to a representative of Vinayak 24x7. Identity
                      proof of the Customer shall be required for delivery of
                      the keys. This service is applicable within a radius of 50
                      km from Customer’s/Policyholder’s registered address. In
                      case such an incidence happens beyond 20 km, Vinayak 24x7
                      shall arrange for sending the same through courier,
                      wherever possible.
                    </li>
                    <li>
                      <em>Towing cost reimbursement:-</em>
                      <br />
                      In case of inability to provide services to immobilized
                      vehicles requiring transfer to garage or workshop, Vinayak
                      24x7 shall reimburse the costs borne by the client in
                      transferring the covered vehicle to the nearest garage up
                      to a maximum of Eight Hundred (Rs 800 only) for Four
                      Wheeler’s &amp; up to a maximum of Rupees Five Hundred (Rs
                      500 only) for Two Wheeler’s. The reimbursement is subject
                      to prior approval by Vinayak 24x7 and shall be limited to
                      avail one time during the period of coverage. Vinayak
                      reserves the right to requisition adequate documentary or
                      other evidence justifying the self-arrangement and costs.
                    </li>
                    <li>
                      <em>Relay of urgent messages :-</em>
                      <br />
                      Our urgent messages relay service help you keep your
                      family and friends informed in case of an accident or
                      vehicle breakdown.
                    </li>
                  </ul>
                  <p>
                    Transfer /Transportation for Mechanical &amp; Accidental
                    Breakdown of Covered Vehicle:-
                  </p>
                  <p>
                    If the covered vehicle is immobilized due to a breakdown or
                    accident and an "on-site" repair is impossible, Vinayak must
                    organize the transfer of the covered vehicle to the nearest
                    workshop. For Mechanical / Electrical breakdowns transfer to
                    the nearest workshop shall be done exclusively on flatbeds.
                    <br />
                    For accidental cases with frontal damage or cases where the
                    vehicle cannot be loaded on a platform, the vehicles must be
                    transferred to the nearest approved workshop/workshop using
                    appropriate equipment. For all services, Vinayak is fully
                    committed to ensuring complete coordination until the
                    vehicle is delivered to the destination workshop.
                  </p>
                  <p>Removal of Covered Vehicle.</p>
                  <p>
                    In case the Covered Vehicle has fallen in a pit and removal
                    or extraction of the vehicle is needed, Vinayak shall
                    arrange the service on a payable basis. These costs shall be
                    paid on-spot by the customer directly to the service
                    provider.
                  </p>
                  <p>Legal co-ordination:-</p>
                  <p>
                    In case of any legal problem arising due to a breakdown or
                    accident, especially when the customer is travelling
                    outstation, Vinayak shall provide contact details of the
                    nearby professionals in related fields and earnestly try to
                    ensure their first contact, to provide convenience to such
                    customers. . In this area Vinayak shall merely be a
                    facilitator and shall not be held responsible for the
                    quality of services. All monetary or other transactions
                    shall be directly between the customer and the service
                    provider. Vinayak role shall end as soon as we provide
                    contact details to the customer. In case such services are
                    not available in that area Vinayak not be held responsible
                    in any manner, whatsoever.
                  </p>
                  <p>Contacting us</p>
                  <p>
                    If you have any questions about this Terms &amp; Conditions,
                    the practices of this site, or your dealings with this site,
                    please contact us at:
                    <br />
                    <br />
                    Vinayak 24x7
                    <br />
                    www.vinayak24x7.com/
                    <br />
                    Plot No.7, Bajrang Vihar Rd, near Durgapura Railway Station,
                    above CK BIRLA HOSPITAL, Shanti Nagar, Durgapura, Jaipur,
                    Rajasthan 302018
                    <br />
                    Email :&nbsp;
                    <a href="mailto:vinayak24x7@gmail.com">
                      vinayak24x7@gmail.com
                    </a>
                    <br />
                    Phone : 6367607678
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
